<template>
  <SeoBlogArticle :content="$t('seoArticleComoCriarUtm')"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
export default {
  name: 'ArticleComoCriarUtm',
  components: { SeoBlogArticle },
}
</script>
